export enum AnalysisDisplayType {
  Distance = 1,
  Segment,
}

export enum DisplayModeTime {
  Summary = 1,
  Segment,
}
